import Pusher from "pusher-js";
import { pusherConfig } from "../config";

export const pusher = new Pusher(pusherConfig.key, {
  cluster: pusherConfig.cluster,
  forceTLS: true,
});
